<mat-dialog-content>
    <div class="d-flex row">
        <div *ngFor="let radar of radarData" class="col">
            <div>
                <h4 *ngIf="radar.trafficData?.de === 1"> Hauptfahrspur</h4>
                <h4 *ngIf="radar.trafficData?.de !== 1"> {{ radar.trafficData != null ? (radar.trafficData.de - 1) : '' }}. Überholspur</h4>
                <div class="border p-2">
                <h4> Aktuelle Verkehrsdaten</h4>
               <div class="w-100 d-flex justify-content-between">
                    <span> Letzte Messung</span>
                    <span> {{ radar.trafficData?.dateTime | date: 'dd.MM.yyyy H:mm:ss'}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Anzahl KFZ</span>
                    <span> {{ radar.trafficData?.kfzTrafficVolume}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Anzahl LKW</span>
                    <span> {{ radar.trafficData?.lkwTrafficVolume}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Durschnittsgeschwindigkeit PKW [km/h]</span>
                    <span> {{ radar.trafficData?.pkwAverageSpeed}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Durschnittsgeschwindigkeit LKW [km/h]</span>
                    <span> {{ radar.trafficData?.lkwAverageSpeed}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Mittlere Geschwindigkeit KFZ [km/h]</span>
                    <span> {{ radar.trafficData?.kfzSmoothedAverageSpeed}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Stdabw. Geschwindigkeit KFZ [km/h]</span>
                    <span> {{ radar.trafficData?.kfzStdDeviation}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Mittlere Zeitlücke [s]</span>
                    <span> {{ radar.trafficData?.meanNetTimeGap}}</span>
                </div>
                 <div class="w-100 d-flex justify-content-between">
                    <span> Belegung [%]</span>
                    <span> {{ radar.trafficData?.utilization}}</span>
                </div>
                </div>
                <div class="border p-2">
                <h4>Ergebnisse Verkehrsdatenanalyse</h4>               
                <div class="w-100 d-flex justify-content-between">
                    <span> Auslöser</span>
                    <span> {{ radar.trigger}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Verkehrsstufe</span>
                    <span> {{ getZName(radar.Z)}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Verkehrssituation</span>
                    <span> {{ radar.VS}}</span>
                </div>
<!--                
                <div class="w-100 d-flex justify-content-between">
                    <span> Analyse basierend auf Messung vom</span>
                    <span> {{ radar.trafficAnalysisData?.Time | date: 'dd.MM.yyyy H:mm:ss'}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Anzahl KFZ</span>
                    <span> {{ radar.trafficAnalysisData?.kfzTrafficVolume}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Anzahl LKW</span>
                    <span> {{ radar.trafficAnalysisData?.lkwTrafficVolume}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Durschnittsgeschwindigkeit PKW</span>
                    <span> {{ radar.trafficAnalysisData?.pkwAverageSpeed}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Durschnittsgeschwindigkeit LKW</span>
                    <span> {{ radar.trafficAnalysisData?.lkwAverageSpeed}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Durschnittsgeschwindigkeit KFZ</span>
                    <span> {{ radar.trafficAnalysisData?.kfzSmoothedAverageSpeed}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Standardabweichung KFZ</span>
                    <span> {{ radar.trafficAnalysisData?.kfzStandardDeviation}}</span>
                </div>
                <div class="w-100 d-flex justify-content-between">
                    <span> Mittlere Zeitlücke</span>
                    <span> {{ radar.trafficAnalysisData?.meanNetTimeGap}}</span>
                </div>
                 <div class="w-100 d-flex justify-content-between">
                    <span> Belegung</span>
                    <span> {{ radar.trafficAnalysisData?.Utilization}}</span>
                </div>
 -->            
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>